/* ⚛ REACT */
import { useState } from "react";

/* 🎨 STYLES */
import { Container, ContainerInput, CheckboxInput, CheckboxMark, Text } from "./styles";

const InputCheckboxFilter = (props) => {
    const [checked, setChecked] = useState(props.checked === true)

    return(
        <Container $aling={props.aling}>
            <ContainerInput>
                <CheckboxInput id={props.text} checked={checked} 
                onChange={()=>{
                    props.onChange(!checked)
                    setChecked(!checked)
                }} />
                <CheckboxMark checked={checked} 
                onClick={()=>{
                    props.onChange(!checked)
                    setChecked(!checked)
                }}/>
                <Text htmlFor={props.text}>{props.text}</Text>
            </ContainerInput>
        </Container>
    )
}

export default InputCheckboxFilter;